import React from "react";
import {RRule} from "rrule";
import {CustomThemeContext} from "js/common/themes/CustomThemeProvider";
import moment from "moment/moment";

const ScheduleSummary = ({
  config,
  frequencyOptions,
  monthlyPatternInfo,
  timezoneOptions,
  monthOptions,
  showRRule = false,
  rrule,
  style
}) => {
  const {themeId} = React.useContext(CustomThemeContext).theme;
  const byMonth = config.get("bymonth");
  const monthsLabel = React.useMemo(() => {
    return byMonth
        .map(monthValue =>
            monthOptions.find(option => option.get("value") === monthValue)?.get("label")
        )
        .filter(Boolean)
        .reduce((acc, label, index, arr) => {
          if (index === arr.count() - 1 && arr.count() > 1) {
            return acc + " and " + label;
          }
          return acc + (index === 0 ? "" : ", ") + label;
        }, "");
  }, [byMonth, monthOptions]);

  const startDate = config.get("startDate");
  const isValidStartDate = React.useMemo(() => {
    return moment(startDate).isValid();
  }, [startDate]);

  return (
      <>
        <div
            style={{
              padding: "12px",
              backgroundColor: themeId === "light" ? "#f0f7ff" : "#153f6e",
              borderRadius: "4px",
              borderLeft: "4px solid #2196f3",
              minHeight: 95,
              ...style
            }}
        >
          <strong>Schedule Summary:</strong>
          <div style={{marginTop: "8px", fontSize: "13px"}}>
            Every {config.get("interval") > 1 && `${config.get("interval")} `}
            {config.get("interval") > 1
                ? frequencyOptions
                    .find((o) => o.get("value") === config.get("freq"))
                    ?.get("label")
                    .toLowerCase()
                    .replace("dai", "day")
                    .replace(/ly$/, "s")
                : frequencyOptions
                    .find((o) => o.get("value") === config.get("freq"))
                    ?.get("label")
                    .toLowerCase()
                    .replace("dai", "day")
                    .replace(/ly$/, "")}
            {isValidStartDate && (
                <>
                  {config.get("freq") === RRule.MONTHLY &&
                      config.get("monthlyPattern") === "dayOfMonth" &&
                      ` on day ${monthlyPatternInfo.dayOfMonth}`}
                  {config.get("freq") === RRule.MONTHLY &&
                      config.get("monthlyPattern") === "dayOfWeek" &&
                      ` on the ${monthlyPatternInfo.ordinal} ${monthlyPatternInfo.dayName}`}
                  {config.get("freq") === RRule.YEARLY &&
                      ` on day ${new Date(config.get("startDate")).getUTCDate()} of ${monthsLabel}`}
                  {" between "} {moment(config.get("startTime"), "HH:mm").format("h A")} - {moment(config.get("startTime"), "HH:mm")
                    .add(1, "hour")
                    .format("h A")} {timezoneOptions.find((o) => o.get(
                    "value") === config.get("timezone"))?.get("label")}
                  {" starting on "} {moment(config.get("startDate")).format("L")}
                </>
            )}
            {config.get("endMode") === "until" &&
                config.get("until") &&
                ` and ending on ${moment(config.get("until")).format("L")}`}
            {config.get("endMode") === "count" &&
                config.get("count") &&
                ` for ${config.get("count")} occurrence${config.get("count") > 1 ? "s" : ""}`}
            {config.get("endMode") === "never" && `, continuing indefinitely`}
          </div>
        </div>

        {showRRule && (
            <div
                style={{
                  marginTop: "12px",
                  padding: "12px",
                  backgroundColor: themeId === "light" ? "#f5f5f5" : "#333b44",
                  borderRadius: "4px",
                  borderLeft: "4px solid #9e9e9e"
                }}
            >
              <strong>RRule String:</strong>
              <div
                  style={{
                    marginTop: "8px",
                    fontSize: "12px",
                    fontFamily: "monospace",
                    wordBreak: "break-all",
                    color: themeId === "light" ? "#424242" : "inherit"
                  }}
              >
                {rrule || "Not set"}
              </div>
            </div>
        )}
      </>
  );
};

export default ScheduleSummary;
